export default __webpack_public_path__ + "static/media/P3.f0f766be.png";